import { NgModule } from '@angular/core'
import { ButtonComponent } from './button.component'
import { CommonModule } from '@angular/common'
import { MatButtonModule } from '@angular/material/button'
import { RouterModule } from '@angular/router'
import {
  ButtonTextDirective,
  ButtonLargeDirective,
  ButtonMediumDirective,
  ButtonOutlinedDirective,
  ButtonSmallDirective,
  ButtonXLargeDirective,
  ButtonXSmallDirective,
  ButtonResponsiveDirective,
  ButtonElevatedDirective,
} from './button.directive'

@NgModule({
  declarations: [
    ButtonComponent,
    ButtonTextDirective,
    ButtonOutlinedDirective,
    ButtonElevatedDirective,
    ButtonXSmallDirective,
    ButtonSmallDirective,
    ButtonMediumDirective,
    ButtonLargeDirective,
    ButtonXLargeDirective,
    ButtonResponsiveDirective,
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    RouterModule,
  ],
  exports: [
    ButtonComponent,
    ButtonTextDirective,
    ButtonOutlinedDirective,
    ButtonElevatedDirective,
    ButtonXSmallDirective,
    ButtonSmallDirective,
    ButtonMediumDirective,
    ButtonLargeDirective,
    ButtonXLargeDirective,
    ButtonResponsiveDirective,
  ],
})
export class ButtonModule { }
